/** @format */
import axios from 'axios';
import qs from 'qs';

import { IntercomIdentityVerification } from '@toucan/common/features/intercom';

// `market` is expected to be lowercase MarketCode
// eslint-disable-next-line @mpb-com/mpb/pure-request-functions -- Legacy code: do not use as an example.
export const getIdentityVerification = async (
    market: string,
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types -- Legacy code: do not use as an example.
    includeContactInformation: boolean = false
) => {
    const queryString = qs.stringify(
        includeContactInformation ? { contact: true } : {},
        { addQueryPrefix: true }
    );

    const result = await axios.get<IntercomIdentityVerification>(
        `/intercom/identity${queryString}`,
        { headers: { 'X-Market': market } }
    );

    return result.data;
};
